/** Display / sort timestamp from comments GET / PATCH (`updatedTime` on normalized row). */
export function getCommentDisplayTimeRaw(comment) {
  if (!comment) return null
  const value = comment.updatedTime
  return value != null && String(value).trim() !== "" ? value : null
}

/** Sort key: comment time, then postCommentId. */
export function getPostCommentSortKey(comment) {
  const timeRaw = getCommentDisplayTimeRaw(comment)
  const timeMs = timeRaw ? new Date(timeRaw).getTime() : 0
  const id = Number(comment?.postCommentId ?? comment?.id ?? 0)
  return timeMs > 0 ? timeMs : id
}

/** Oldest → newest (API default order). */
export function sortPostCommentsByTime(comments, direction = "asc") {
  const list = Array.isArray(comments) ? [...comments] : []
  list.sort((a, b) => {
    const ka = getPostCommentSortKey(a)
    const kb = getPostCommentSortKey(b)
    if (ka === kb) {
      const idA = Number(a?.postCommentId ?? a?.id ?? 0)
      const idB = Number(b?.postCommentId ?? b?.id ?? 0)
      return direction === "desc" ? idB - idA : idA - idB
    }
    return direction === "desc" ? kb - ka : ka - kb
  })
  return list
}

/** Newest comments first, for compact preview UI (deduped by comment id). */
export function getLatestPostComments(comments, count = 2) {
  const sorted = sortPostCommentsByTime(comments, "desc")
  const seen = new Set()
  const unique = []
  for (const comment of sorted) {
    const id = comment?.postCommentId ?? comment?.id
    const key =
      id != null && String(id).trim() !== ""
        ? `id:${id}`
        : `t:${getPostCommentSortKey(comment)}:${comment?.commentText ?? ""}`
    if (seen.has(key)) continue
    seen.add(key)
    unique.push(comment)
    if (unique.length >= count) break
  }
  return unique
}

export function getLatestPostComment(comments) {
  const sorted = sortPostCommentsByTime(comments, "asc")
  return sorted.length > 0 ? sorted[sorted.length - 1] : null
}
